export default function Footer() {
  return (
    <div className="checkup-data-prescription-card-footer">
      <span>Medi Care</span>
      <span>Magsaysay Bayombong N.V.</span>
    </div>
  );
}
